import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const billingPlugin = createPlugin({
  id: 'billing',
  routes: {
    root: rootRouteRef,
  }
});

export const BillingPage = billingPlugin.provide(
  createRoutableExtension({
    name: 'BillingPage',
    component: () =>
      import('./components/BillingComponent').then(m => m.BillingComponent),
    mountPoint: rootRouteRef,
  }),
);
